import React, { useState } from "react";
import DropdownInput from "./DropdownInput";
import Input from "./Input";
import TextArea from "./TextArea";
import { Icon } from "semantic-ui-react";

// react-bootstrap components
import {
  Button,
  Card,
  Container,
  Row,
  Col,
  Form,
  FormCheck,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import ECReCaptcha from "./ECRecaptcha";
import { Link } from "react-router-dom";
import FileUpload from "./FileUpload";

import { MEDICAL_ITEMS } from "./../../constants/medical-items.constant";
import { PRODUCT_ITEMS } from "./../../constants/products.constant";
import { useAccount, useMsal } from "@azure/msal-react";
import { msalConfig } from "../../configs/MSAL.config";
import { ALL_ITEMS } from "../../constants/all-items.constant";

const IssueRequestForm = (props) => {
  const { accounts, instance } = useMsal();
  const account = useAccount(accounts[0]);
  const [certificateType, setCertificateType] = useState(false);
  const [medAffairsAssignment, setMedAffairsAssignment] = useState(true);

  const handleChangeMedicalAffairsAssignment = ($event) => {
    setMedAffairsAssignment($event.target.value === "true");
    props.setValue("IssueCategory", "");
  };

  const handleChangeCertificateType = ($event) => {
    const value = $event.target.value;
    if (value === "false") {
      props.setValue("CertOnBehalfOf", null);
    }
    setCertificateType(value === "true");
  };

  const handleVerify = (token) => {
    props.setValue("recaptchaToken", token, { shouldDirty: true });
    // console.log(token);
  };

  const login = async () => {
    try {
      await instance.loginRedirect({
        authority: process.env.REACT_APP_MSAL_AUTHORITY,
        scopes: msalConfig.auth.scopes,
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Container fluid className="mt-20">
      <Row>
        <Col lg="12">
          <form
            onSubmit={props.handleSubmit(
              props.handleSubmitIssue,
              props.handleSubmitError
            )}
          >
            <Card className="card-stats">
              <Card.Header>
                <Card.Title as="h1">
                  Essilor Medical Affairs Inquiries{" "}
                </Card.Title>
                <p />
                <Card.Subtitle as="h2">
                  Submit an Issue or Request
                </Card.Subtitle>
                <p />
                <p>Dear Clinician,</p>
                <p>
                  Please fill out the form below and we will route it to the
                  appropriate specialist. We will respond as soon as possible.
                </p>
                <p>Please allow up to 14 days.</p>
                  <p><strong>NOTE - </strong>After 14 days please check your SPAM and/or PROMOTIONS folder in your email box. We will send you an email from: no-reply@essilorusa.com with the subject that starts with "Essilor Medical Affairs..."</p>
                <hr />
              </Card.Header>
              <Card.Body>
                <div className="container">
                  <div className="row">
                    {!account?.idTokenClaims?.sub && (
                      <>
                        <div className="row">
                          <div className="col-sm-12">
                            <Button variant={"primary"} onClick={login}>
                              <Icon name="sign-out" /> Login with EssilorPRO®
                            </Button>
                          </div>
                        </div>
                        <div className="row mt-20 mb-20">
                          <div className="col-sm-12">
                            <h3>OR</h3>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <Form.Label>* Required Fields</Form.Label>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <Input
                              type={"text"}
                              register={props.register("firstName", {
                                required: true,
                              })}
                              label={"First name"}
                              errors={props.errors.firstName}
                              required={true}
                            ></Input>
                          </div>
                          <div className="col-sm-6">
                            <Input
                              type={"text"}
                              register={props.register("lastName", {
                                required: true,
                              })}
                              label={"Last name"}
                              errors={props.errors.lastName}
                              required={true}
                            ></Input>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-sm-12 col-md-6">
                            <Input
                              type={"email"}
                              register={props.register("email")}
                              label={"Email"}
                              errors={props.errors.email}
                              required={true}
                            ></Input>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="row mt-2">
                      <div className="col-sm-12 col-md-6">
                        <DropdownInput
                          register={props.register("IssueCategory", {
                            required: true,
                          })}
                          label={"Issue Category"}
                          items={ALL_ITEMS}
                          errors={
                            props.errors.IssueCategory ||
                            props.errors.IssueCategory?.message
                          }
                          required={true}
                        ></DropdownInput>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-sm-12">
                        <TextArea
                          register={props.register("IssueDesc", {
                            required: true,
                          })}
                          label={"Issue Description"}
                          rows={4}
                          errors={props.errors.IssueDesc}
                          required={true}
                        ></TextArea>
                      </div>
                    </div>

                    <div className="row flex-row-reverse mt-2">
                      <div className="col-sm-12 d-flex flex-column mt-10">
                        <InputGroup>
                          <FormCheck
                            {...props.register("CertFlag", {
                              required: true,
                            })}
                            type="radio"
                            label="Certification for myself"
                            onChange={handleChangeCertificateType}
                            value={"false"}
                            name={"certification-type"}
                          />
                        </InputGroup>
                        <InputGroup>
                          <FormCheck
                            {...props.register("CertFlag", {
                              required: true,
                            })}
                            type="radio"
                            label="Certification on behalf of"
                            onChange={handleChangeCertificateType}
                            value={"true"}
                            name={"certification-type"}
                          />
                        </InputGroup>
                        {props.errors.CertFlag && (
                          <span className={"error-validation"}>
                            This field is required
                          </span>
                        )}
                        {certificateType && (
                          <Input
                            register={props.register("CertOnBehalfOf", {
                              required: true,
                            })}
                            label={"Doctor's name "}
                          ></Input>
                        )}
                        {certificateType && props.errors.CertOnBehalfOf && (
                          <span className={"error-validation"}>
                            This field is required
                          </span>
                        )}
                        {/* <Form.Label>
                          <span>
                            Issue/Request File

                            <img className="helpIcon" onClick={handleShowFileTypes} alt="help" src={helpIcon}/>
                          </span>
                        </Form.Label>
                        <Form.Group controlId="formFile" className="mb-3">
                          <Form.Control
                            {...props.register("issueFile", {
                              validate: {
                                lessThan50: v => (v[0]?.size || 0) < 50000000 || "Max of 50mb",
                                acceptedFormats: files =>
                                  ([
                                    'image/jpeg',
                                    'image/png',
                                    'image/gif',
                                    'application/pdf',
                                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                    'video/mp4',
                                    'video/quicktime',
                                    'application/vnd.ms-powerpoint',
                                    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                  ].includes(
                                    files[0]?.type
                                  ) || files.length === 0) || 'File type is not allowed. Click ? to see the allowed files',
                              },
                            })}
                            type="file"
                          />
                          {props?.errors?.issueFile?.message && <Form.Control.Feedback type="invalid" style={props?.errors?.issueFile?.message ? {display:'block'} : { display: 'none'}}>{props?.errors?.issueFile?.message}</Form.Control.Feedback>}
                        </Form.Group> */}
                        <br/>
                        <FileUpload
                          register={props.register}
                          errors={props.errors}
                        />
                        <ECReCaptcha handleToken={handleVerify} />
                        <input
                          type="hidden"
                          {...props.register("recaptchaToken", {
                            required: true,
                          })}
                        />
                        {props.errors.recaptchaToken && (
                          <Form.Control.Feedback
                            type="invalid"
                            style={
                              props.errors.recaptchaToken
                                ? { display: "block" }
                                : { display: "none" }
                            }
                          >
                            This field is required
                          </Form.Control.Feedback>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
              <Card.Footer>
                <hr></hr>
                <Button
                  disabled={props.isLoading}
                  className="float-end btn-fill"
                  type="submit"
                  variant="primary"
                >
                  Submit Issue/Request
                  {props.isLoading && (
                    <Spinner animation="border" role="status" size="sm">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  )}
                </Button>
              </Card.Footer>
            </Card>
          </form>
        </Col>
      </Row>
    </Container>
  );
};

export default IssueRequestForm;
